import React, { useCallback } from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';

type Props = {
  matchInfoUrl: string | undefined | null;
};

const MatchInfoButton = React.memo((props: Props) => {
  const { matchInfoUrl } = props;

  const openMatchInfo = useCallback(() => {
    if (matchInfoUrl) window.open(matchInfoUrl, '_blank');
  }, [matchInfoUrl]);

  return matchInfoUrl ? (
    <Tooltip title="Opens external website with match info" placement="top" arrow>
      <IconButton onClick={openMatchInfo}>
        <LinkIcon />
      </IconButton>
    </Tooltip>
  ) : (
    <div />
  );
});

export default MatchInfoButton;
